import {Modal, ModalBackdrop, ModalCloseButton} from "components/Common";
import React, {useCallback, useEffect, useState} from "react";
import {IconClose, TutorialActions} from "components";
import styled from "@emotion/styled";
import {AdobeTrackActionActions, TutorialSteps} from "modules/enums";
import {useDispatch, useSelector} from "react-redux";
import {sendTutorialModalViewed, setIsTutorialViewed, toggleTutorialModal} from "modules/actions";
import {getIsTutorialModalOpen, getIsTutorialViewed, getUserStore} from "modules/selectors";
import {TutorialMainStep} from "components/Modals/TutorialModal/TutorialMainStep";
import {FirstTutorialStep} from "components/Modals/TutorialModal/FirstTutorialStep";
import {get} from "lodash";
import {AdobeAnalyticService} from "modules/utils/Services/AdobeAnalyticService";

const SModal = styled(Modal)`
	padding: 40px 16px;
`;

const stepsMapper = {
	[TutorialSteps.Introduce]: <TutorialMainStep />,
	[TutorialSteps.First]: <FirstTutorialStep />,
};

export const TutorialModal: React.FC = () => {
	const dispatch = useDispatch();
	const isOpen = useSelector(getIsTutorialModalOpen);
	const isViewed = useSelector(getIsTutorialViewed);
	const [activeStep, setActiveStep] = useState<TutorialSteps>(TutorialSteps.Introduce);
	const user = useSelector(getUserStore).currentUser;

	const handleClose = () => {
		const action =
			activeStep === TutorialSteps.Introduce
				? AdobeTrackActionActions.WelcomeModalExit
				: AdobeTrackActionActions.HowToPlayExit;

		AdobeAnalyticService.TrackAction({
			"action.name": action,
			"action.element.text": "",
			"action.element.targetUrl": "",
			"action.element.index": 2,
		});
		closeModal();
	};

	const closeModal = useCallback(() => {
		dispatch(toggleTutorialModal(false));
		dispatch(sendTutorialModalViewed());
	}, [dispatch]);

	useEffect(() => {
		if (!user) {
			return;
		}

		if (!user.isTutorialViewed) {
			dispatch(setIsTutorialViewed(false));
			dispatch(toggleTutorialModal(true));
		}
	}, [user, dispatch]);

	useEffect(() => {
		setActiveStep(Number(isViewed));
	}, [isViewed]);

	if (!isOpen) {
		return null;
	}

	return (
		<ModalBackdrop>
			<SModal>
				<ModalCloseButton onClick={handleClose}>
					<IconClose />
				</ModalCloseButton>

				<React.Fragment>
					{get(stepsMapper, activeStep, TutorialSteps.Introduce)}
				</React.Fragment>

				<TutorialActions
					activeStep={activeStep}
					setActiveStep={setActiveStep}
					closeClick={closeModal}
				/>
			</SModal>
		</ModalBackdrop>
	);
};
